import React, {useEffect, useState} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Form, Button, Card, notification, Select, Drawer, Spin} from 'antd'
import GetAllFormFields from '../../../components/_utils/formUtils'
import {addAreaAction, updateAreaAction, listAreaAction} from '../actions'
import {useDispatch} from 'react-redux'
import {goBack} from 'connected-react-router'
import {handlePreview} from "../../../request";

const AddArea = props => {
    const [loader, setLoader] = useState(false)
    const [id, setId] = useState(null)
    const [showStaff, setStaffShow] = useState(false)
    const dispatch = useDispatch()

    const [form] = Form.useForm()
    let {resetFields, setFieldsValue, getFieldValue} = form
    const {open, onClose, onSubmit} = props;

    const onFinish = async values => {

        let x = null
        setLoader(true)
        if (id) {
            values._id = id
            x = await updateAreaAction(values)
            setLoader(false)

        } else {
            x = await addAreaAction(values)
            setLoader(false)

        }

        if (!x.error) {
            notification.success({
                message: x.message
            })
            if (!id) {
                setStaffShow(false)
                // resetFields()
                onSubmit()
                onClose()
            } else {
                // dispatch(goBack())
                onSubmit()
            }

        } else {
            notification.error({
                message: x.message ? x.message : 'Error Saving'
            })
        }
    }

    const onFinishFailed = errorInfo => {
        return notification.error({
            message: 'Please Fill All Required Fields'
        })
    }


    useEffect(async () => {
        if (id) {
            setLoader(true)
            let {data} = await listAreaAction({_id: id})
            if (data && data.length) {
                let agent = data[0]
                setFieldsValue({...agent})
            }
            setLoader(false)


        }
    }, [id])

    const subInputTypes1 = {
        fields: [

            {
                label: 'Name',
                key: 'name',
                required: true
            },
           
            {
                label: 'Slug',
                key: 'slug',
                required: true,
            },

        ]
    }

    return (
        <Drawer 
        title={id ? 'Update Area' : 'Add Area'}
        visible={open}
        onClose={onClose}
        width={500}
        destroyOnClose={true}
        >
            <Card bordered={false}>
                <Spin spinning={loader} >
                <div>
                    <Form
                        form={form}
                        name="basic"
                        labelCol={{span: 8}}
                        wrapperCol={{span: 16}}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}>

                        <GetAllFormFields inputSchema={subInputTypes1}/>
                        <Form.Item wrapperCol={{offset: 8, span: 16}}>
                            <Button type="primary" htmlType="submit" loading={loader}>
                                {id ? 'Update' : 'Add'}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
                </Spin>

            </Card>
        </Drawer>
    )
}

export default AddArea
